// extracted by mini-css-extract-plugin
module.exports = {"container":"error-panel_container__2FxO5"};